import { render, staticRenderFns } from "./veStuXjAuditEdit.vue?vue&type=template&id=06162fcc&scoped=true"
import script from "./veStuXjAuditEdit.vue?vue&type=script&lang=js"
export * from "./veStuXjAuditEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06162fcc",
  null
  
)

export default component.exports